import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

const firstControlDigitWeights = [3, 7, 6, 1, 8, 9, 4, 5, 2];
const secondControlDigitWeights = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];

function getControlDigit(digits: number[], weights: number[]): number {
  const weightedSum = weights.reduce((sum, weight, index) => sum + weight * digits[index], 0);
  const controlDigit = 11 - (weightedSum % 11);

  return controlDigit === 11 ? 0 : controlDigit;
}

export const norwegianNationalIdentityNumberValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  const value = (control.value ?? '').toString();

  if (!value.trim()) {
    return null;
  }

  if (!/^\d{11}$/.test(value)) {
    return { norwegianNationalIdentityNumber: true };
  }

  const digits = value.split('').map(Number);
  const isValid = digits[9] === getControlDigit(digits, firstControlDigitWeights)
    && digits[10] === getControlDigit(digits, secondControlDigitWeights);

  return isValid ? null : { norwegianNationalIdentityNumber: true };
};
